import React from "react"
import { useState } from "react"
import { useEffect } from "react"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import { Container } from "react-bootstrap"
import { Row } from "react-bootstrap"
import Header from "components/Header/Header"
import { Col } from "react-bootstrap"
import { Typography, styled, Grid, Box } from "@mui/material"
import AppDatePicker from "components/AppDatePicker"
import { Formik } from "formik"
import AppTextArea from "components/StyledComponents/AppTextArea"
import { validationSchemaRaffleTicket } from "helpers/validationSchema"
import AppButton from "components/StyledComponents/AppButton"
import moment from "moment"
import "moment-timezone"
import { useDispatch, useSelector } from "react-redux"
import { getRaffleListDataAction } from "redux/marketing/actions"
import { raffleTicketAction } from "redux/marketing/actions"
import RaffleTable from "./raffleTable"
import { useHistory } from "react-router-dom"
import AppTextField from "components/StyledComponents/AppTextField"
import { marketingActions } from "redux/marketing/slice/user"

const StyledLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginBottom: 8,
  "& span": {
    color: theme.palette.error.main
  }
}))

const months = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12"
}

const initialData = {
  start_date: "",
  dinner_time: "",
  wine_club_dinner: "",
  description: "",
  time: "",
  time_zone: null
}

function TriviaConfiguration() {
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const [initialValuesRaffle] = useState({ ...initialData })

  const dispatch = useDispatch()
  const history = useHistory()
  const zone_name = moment.tz.guess()

  const { raffleListData } = useSelector((state) => state?.marketing?.raffleContestData || {})
  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    document.title = "Raffle Configuration"
  }, [])

  // function convertTime(date, time) {
  //     const formatTime = (moment(new Date(date)).format('ddd MMM DD YYYY') + " " + time)
  //     return new Date(formatTime).toUTCString();
  // }

  function convertDate(date, time) {
    const forDate = moment(new Date(date)).format("ddd MMM DD YYYY") + " " + time
    const newDate = new Date(forDate)
    return newDate.toUTCString()
  }
  function payloadDate(dateArray = [], timeStamp) {
    console.log("timestamp", timeStamp, "date", dateArray)
    return `${dateArray[3]}-${months[dateArray[2]]}-${dateArray[1]}`
  }

  const handleSubmit = (values) => {
    const { start_date, description, time } = values

    const RaffleTimeStamp = convertDate(start_date, time)
    // const dinnerTimeStamp = convertDate(wine_club_dinner, dinner_time)
    const RaffleTimeSplit = RaffleTimeStamp.split(" ")
    // const RaffleDinnerTimeSplit = dinnerTimeStamp.split(" ")
    const RaffleStartDate = RaffleTimeSplit.toString().replace(/,/g, " ")
    // const RaffleWinnerDate = RaffleDinnerTimeSplit.toString().replace(/,/g, ' ')
    const payloadStartDate = payloadDate(RaffleTimeSplit, RaffleStartDate)
    // const payloadWinnerDate = payloadDate(RaffleDinnerTimeSplit, RaffleWinnerDate)

    const payload = {
      start_date: payloadStartDate,
      // dinner_time: RaffleDinnerTimeSplit[4],
      time: RaffleTimeSplit[4],
      // wine_club_dinner: payloadWinnerDate,
      description: description,
      time_zone: zone_name
    }

    dispatch(raffleTicketAction(payload))
    history.push("/marketing/dashboard")
  }

  useEffect(() => {
    dispatch(getRaffleListDataAction())
  }, [])

  useEffect(() => {
    dispatch(marketingActions.setRaffleSingleData({}))
  }, [])

  return (
    <>
      <Container fluid className="p-0">
        <Row>
          <Header title="Contest Configuration" back={true} breadCrumbs={breadCrumbs} />
        </Row>
      </Container>
      <Container fluid className="p-0 mt-4">
        <Row>
          <Col lg="12" className="mt-4">
            <Formik
              initialValues={initialValuesRaffle}
              enableReinitialize={true}
              validationSchema={validationSchemaRaffleTicket}
              onSubmit={handleSubmit}>
              {(formik) => (
                <>
                  <Grid container spacing={3}>
                    <Grid item sm={12} md={6} lg={4} className="datesContainer">
                      <StyledLabel variant="body1Regular">
                        {"Start Date"}
                        <span>*</span>
                      </StyledLabel>
                      <Box className="dateFieldContainer w-100 mt-2">
                        <AppDatePicker
                          minDate={new Date()}
                          maxDate={new Date().setMonth(new Date().getMonth() + 5)}
                          inputFormat="dd MMM yyyy"
                          key={"start_date"}
                          value={formik.values.start_date}
                          onChange={(val) => formik.setFieldValue("start_date", val)}
                          error={formik.errors.start_date}
                          touched={formik.touched.start_date}
                        />
                      </Box>
                    </Grid>
                    <Grid item sm={12} md={6} lg={4}>
                      <AppTextField
                        type="time"
                        fullWidth
                        label="Raffle Start Time"
                        isRequired={true}
                        value={formik.values.time}
                        onChange={formik.handleChange("time")}
                        error={formik.touched.time && Boolean(formik.errors.time)}
                        helperText={formik.touched.time && formik.errors.time}
                      />
                    </Grid>
                    {/* <Grid item sm={12} md={6} lg={4} className="datesContainer">
                      <StyledLabel variant="body1Regular">
                        {"Wine Club Dinner Date"}
                        <span>*</span>
                      </StyledLabel>
                      <Box className="dateFieldContainer w-100 mt-2">
                        <AppDatePicker
                          disabled={formik.values.start_date ? false : true}
                          minDate={new Date(formik.values.start_date).setDate(
                            new Date(formik.values.start_date).getDate() + 1
                          )}
                          maxDate={new Date(formik.values.start_date).setMonth(
                            new Date(formik.values.start_date).getMonth() + 2
                          )}
                          inputFormat="dd MMM yyyy"
                          key={"wine_club_dinner"}
                          error={formik.errors.wine_club_dinner}
                          touched={formik.touched.wine_club_dinner}
                          value={formik.values.wine_club_dinner}
                          onChange={(val) => formik.setFieldValue("wine_club_dinner", val)}
                        />
                      </Box>
                    </Grid>
                    <Grid item sm={12} md={6} lg={4}>
                      <AppTextField
                        type="time"
                        fullWidth
                        label="Dinner Time"
                        isRequired={true}
                        value={formik.values.dinner_time}
                        onChange={formik.handleChange("dinner_time")}
                        error={formik.touched.dinner_time && Boolean(formik.errors.dinner_time)}
                        helperText={formik.touched.dinner_time && formik.errors.dinner_time}
                      />
                    </Grid> */}
                    <Grid item sm={12} md={6} lg={4}>
                      <AppTextArea
                        label="Description"
                        isRequired={true}
                        id="description"
                        placeholder="Enter Description"
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        error={formik.errors.description}
                        touched={formik.touched.description}
                      />
                    </Grid>
                  </Grid>
                  <Row>
                    <Col lg="2" className="mt-4">
                      <AppButton onClick={formik.handleSubmit}>Submit</AppButton>
                    </Col>
                  </Row>
                </>
              )}
            </Formik>
          </Col>
        </Row>
      </Container>
      <Container fluid className="p-0 mt-5">
        <Row>
          <Col lg="12">
            <RaffleTable columns={RaffleColumns} rows={raffleListData}></RaffleTable>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default TriviaConfiguration

const RaffleColumns = [
  {
    id: "contest",
    label: "Raffle Contest Date",
    align: "left",
    minWidth: 170
  },
  {
    id: "contestTime",
    label: "Raffle Contest Start Time",
    align: "center",
    minWidth: 170
  },
  // {
  //   id: "Wine Club Dinner Date",
  //   label: "Wine Club Dinner Date",
  //   align: "center",
  //   minWidth: 170
  // },
  // {
  //   id: "Wine Club Dinner Time",
  //   label: "Wine Club Dinner Time",
  //   align: "center",
  //   minWidth: 100
  // },
  {
    id: "actions",
    label: "Actions",
    align: "center",
    minWidth: 50
  }
]
